import { useState } from "react";
import axios from "axios";
import { Coffee, Loader2, Shield } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function LiveDayBreakButton({ date }) {
  const [open, setOpen] = useState(false);
  const [minutes, setMinutes] = useState(10);
  const [checking, setChecking] = useState(false);
  const [result, setResult] = useState(null);

  const check = async () => {
    setChecking(true);
    setResult(null);
    try {
      const now = new Date();
      const currentTime = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
      const localDate = date || `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
      const { data } = await axios.post(
        `${API}/api/diary-intelligence/live-day/break-impact`,
        { date: localDate, current_time: currentTime, break_minutes: Number(minutes) },
        { withCredentials: true });
      setResult(data);
    } catch { setResult({ outcome: "ERROR", message: "NDG could not calculate the effect safely." }); }
    setChecking(false);
  };

  return (
    <div className="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-3">
      <button data-testid="need-break-button" onClick={() => setOpen(v => !v)}
        className="w-full flex items-center justify-center gap-2 text-sm font-extrabold text-slate-700 dark:text-slate-200">
        <Coffee className="w-4 h-4 text-amber-600" /> I need a break
      </button>
      {open && <div className="mt-3 space-y-3">
        <div className="flex gap-2">
          {[5, 10, 15, 20].map(value => (
            <button key={value} onClick={() => setMinutes(value)}
              className={`flex-1 h-10 rounded-xl text-xs font-bold ${minutes === value ? "bg-blue-600 text-white" : "bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300"}`}>
              {value} min
            </button>
          ))}
        </div>
        <button onClick={check} disabled={checking}
          className="w-full h-11 rounded-xl bg-slate-900 dark:bg-blue-600 text-white text-sm font-bold flex items-center justify-center gap-2">
          {checking ? <Loader2 className="w-4 h-4 animate-spin" /> : "Check the effect first"}
        </button>
        {result && <div className={`rounded-xl p-3 text-xs ${result.outcome === "NO_TIME_IMPACT" ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-900"}`}>
          <div className="flex items-start gap-2"><Shield className="w-4 h-4 mt-0.5" /><div>
            <p className="font-extrabold">{result.message}</p>
            {(result.impacts || []).map(x => <p key={x.lesson_id} className="mt-1">
              {x.scheduled_start} → {x.expected_start} · {x.delay_minutes} minutes · {x.action === "NOTIFY_DELAY" ? "notification needed" : "pupil consent needed"}
            </p>)}
            {result.outcome === "APPROVAL_REQUIRED" && <p className="mt-2 font-bold">Nothing has been sent or moved.</p>}
          </div></div>
        </div>}
      </div>}
    </div>
  );
}
